 function pw(id) {
    return document.getElementById(id);
  }

  var pwEl = pw('notify-email');
  var pwBtn = pw('notify-btn');
  var pwWrap = pw('notify-wrap');
  var pwOk = pw('form-success');
  var pwErr = pw('form-error');

  function pwSend() { 
    var v = pwEl.textContent.trim();
    if (!v || v.indexOf('@') < 0) {
      pwEl.focus();
      return;
    }
    var u = 'https://a.klaviyo.com'
      + '/client/subscriptions/'
      + '?company_id=RdEyaa';   
    var d = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',  
              attributes: { email: v }
            }
          }
        },
        relationships: {     
          list: {
            data: {
              type: 'list',
              id: 'WZ9YdK'
            }
          } 
        }
      }
    };
    fetch(u, {
      method: 'POST',        
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-10-15'
      },
      body: JSON.stringify(d)   
    }).then(function(r) {
      if (r.ok || r.status === 202) {
        pwWrap.style.display = 'none';
        pwOk.style.display = '';
      } else {
        pwErr.style.display = '';
      }
    }).catch(function() {
      pwErr.style.display = '';
    });
  }

  pwEl.addEventListener('paste', function(e) {
    e.preventDefault();
    var cd = e.clipboardData
      || window.clipboardData;  
    document.execCommand(
      'insertText', false,
      cd.getData('text/plain')
    );
  });

  pwEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      pwSend();
    }
  });
  
  pwBtn.addEventListener('click', pwSend);